module.exports = __webpack_public_path__ + "static/img/__9998.830e29c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9998.jpg
// module id = 7YrU
// module chunks = 0